import { Box, Typography } from '@mui/material'
import { CardTitle, ChartExportWrapper, CustomDistanceChart } from 'components'
import { Body, Container } from './SpectralDistance.styled'
import { Delivery } from '../../../../../../types'
import { useDeliveriesService } from '../../../../../../services'
import { useQuery } from 'react-query'

type ConsistencyResultProps = {
  delivery?: Delivery
}

export const SpectralDistance = ({ delivery }: ConsistencyResultProps) => {
  const { getSpectralDistanceData } = useDeliveriesService()

  const { data, isLoading } = useQuery(
    ['spectralDistance', delivery?.id],
    () => (delivery?.id ? getSpectralDistanceData(delivery.id) : null),
    {
      enabled: !!delivery?.id,
      select: (res) => res?.result,
    }
  )

  const mappedChartData = data
    ? [
        ...(data.historical_spectral_distances?.map((historicData) => ({
          threshold: data.threshold_line,
          point: historicData.point,
          date: historicData.arrival_date,
        })) || []),
        {
          point: data.point,
          threshold: data.threshold_line,
          date: data.arrival_date,
          current: true,
        },
      ]
    : []

  return (
    <Container>
      <Box px="16px">
        <CardTitle title="Spectral Distance" />
      </Box>
      <Body>
        {!isLoading && mappedChartData.length > 0 ? (
          <ChartExportWrapper title="Spectral Distance">
            <CustomDistanceChart data={mappedChartData} />
          </ChartExportWrapper>
        ) : (
          <Typography>No valid data available</Typography>
        )}
      </Body>
    </Container>
  )
}
